import Route from "@ember/routing/route"

export default class NotFoundRoute extends Route {
  beforeModel /* transition */() {
    this.transitionTo("planbookv5.planner.week") // Implicitly aborts the on-going transition.
  }
}
